<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="itemTable"
      title="사업장별 수질 검사항목"
      tableId="itemTable"
      :columns="griditem.columns"
      :data="griditem.data"
      :columnSetting="false"
      selection="multiple"
      rowKey="envWaterPlantInspectItemId"
      :filtering="false"
      :usePaging="false"
      :editable="editable"
    >
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLADD" v-if="editable" icon="add" @btnClicked="addrowitem" />
          <c-btn label="LBLREMOVE" v-if="editable" icon="remove" @btnClicked="removeRowitem" />
          <c-btn label="LBLSAVE" v-if="editable" icon="save" @btnClicked="saveitem" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'water-master-0601',
  props: {
    param: {
      type: Object,
      default: () => ({
      }),
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
      },
      editable: true,
      griditem: {
        columns: [
          {
            required: true,
            name: 'plantCd',
            field: 'plantCd',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
            style: 'width:200px',
            type: 'plant',
          },
          {
            name: 'envWaterMstInspectItemName',
            field: 'envWaterMstInspectItemName',
            label: '검사항목',
            align: 'left',
            sortable: true,
          },
          {
            name: 'legalStandard',
            field: 'legalStandard',
            label: '법적기준',
            align: 'center',
            type: 'cost',
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: 'innerStandard',
            field: 'innerStandard',
            label: '내부기준',
            align: 'center',
            type: 'number',
            style: 'width: 120px',
            sortable: true,
          },
        ],
        data: [],
      },
      itemListUrl: '',
      itemDeleteUrl: '',
      itemSaveUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '50%',
        param: {},
        closeCallback: null,
      },
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.itemListUrl = selectConfig.env.water.mst.inspect.plant.url;
      this.itemDeleteUrl = transactionConfig.env.water.mst.inspect.plant.delete.url;
      this.itemSaveUrl = transactionConfig.env.water.mst.inspect.plant.save.url;
      
      this.getList();
    },
    getList() {
      this.$http.url = this.itemListUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.griditem.data = _result.data;
      },);
    },
    addrowitem() {
      this.popupOptions.title = '수질 검사항목 검색';
      this.popupOptions.param = {
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'./waterInspectItemPop.vue'}`);
      this.popupOptions.width = '50%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeitem;
    },
    closeitem(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.griditem.data, { envWaterMstInspectItemId: item.envWaterMstInspectItemId }) === -1) {
            this.griditem.data.push({
              envWaterPlantInspectItemId: uid(),  // 사업장별 수질 검사항목 일련번호
              plantCd: this.searchParam.plantCd,  // 사업장코드
              envWaterMstInspectItemId: item.envWaterMstInspectItemId,  // 수질 검사항목 일련번호
              envWaterMstInspectItemName: item.envWaterMstInspectItemName,
              legalStandard: item.legalStandard,
              innerStandard: null,  // 내부기준
              editFlag: 'C',
            })
          }
        })
      }
    },
    saveitem() {
      if (this.$comm.validTable(this.griditem.columns, this.griditem.data)) {
        let saveData = this.griditem.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        if(saveData.length > 0) {
          this.$http.url = this.itemListUrl;
          this.$http.type = 'GET';
          this.$http.request((_result) => {
            let duplicateFlag = false;
            this.$_.forEach(saveData, item => {
              // 전체
              let allCheck = this.$_.filter(_result.data, { 
                plantCd: item.plantCd,  
                envWaterMstInspectItemId: item.envWaterMstInspectItemId,  
              })
              // 현재 테이블
              let currentCheck = this.$_.filter(this.griditem.data, { 
                plantCd: item.plantCd,  
                envWaterMstInspectItemId: item.envWaterMstInspectItemId,  
              })

              // 수정인 경우 전체에서 자기자신 제외
              if (item.editFlag === 'U') {
                allCheck = this.$_.reject(allCheck, { envWaterPlantInspectItemId: item.envWaterPlantInspectItemId })
              }
              if (allCheck.length !== 0 || currentCheck.length !== 1) {
                duplicateFlag = true;
                return false;
              }

              item.regUserId = this.$store.getters.user.userId;
              item.chgUserId = this.$store.getters.user.userId;
            });

            if (!duplicateFlag) {
              window.getApp.$emit('CONFIRM', {
                title: 'LBLCONFIRM',
                message: 'MSGSAVE', // 저장하시겠습니까?
                type: 'info',
                // 확인 callback 함수
                confirmCallback: () => {
                  this.$http.url = this.itemSaveUrl;
                  this.$http.type = 'POST';
                  this.$http.param = saveData;
                  this.$http.request(() => {
                    this.getList();
                    window.getApp.$emit('APP_REQUEST_SUCCESS');
                  });
                },
                // 취소 callback 함수
                cancelCallback: () => {
                },
              });
            } else {
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '입력하신 데이터 중 사업장, 검사항목이\n동일한 데이터가 존재합니다.', /* 입력하신 데이터 중 사업장, 검사항목이 동일한 데이터가 존재합니다. */
                type: 'info', // success / info / warning / error
              });
            }
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: 'MSGNOCHANGEDATA', // 변경된 데이터가 없습니다., /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    removeRowitem() {
      let selectData = this.$refs['itemTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.itemDeleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              // this.getProcessList();
              window.getApp.$emit('APP_REQUEST_SUCCESS');

              this.$_.forEach(selectData, item => {
                this.griditem.data = this.$_.reject(this.griditem.data, item);
              })
              this.$refs['itemTable'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
